import { render, staticRenderFns } from "./SharedInfoCard.vue?vue&type=template&id=eda01662&scoped=true&"
import script from "./SharedInfoCard.vue?vue&type=script&lang=js&"
export * from "./SharedInfoCard.vue?vue&type=script&lang=js&"
import style0 from "./SharedInfoCard.vue?vue&type=style&index=0&id=eda01662&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eda01662",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
installComponents(component, {VDivider})
